<template>
  <div class="row mt-3 no-gutters d-flex align-items-center" :style="type === true ? 'border: 1px solid #77a734' : 'border: 1px solid #d91b5b'">
    <div class="col-2" :style="type === true ? 'border-right: 1px solid #77a734' : 'border-right: 1px solid #d91b5b'">
      <div class="d-flex justify-content-center f-bold p-3" :style="type === true ? 'color: #77a734' : 'color: #d91b5b'">
        <span v-if="type">
          <i class="far fa-check-circle fa-3x"/>
        </span>
        <span v-else>
          <i class="far fa-times-circle fa-3x"/>
        </span>
      </div>
    </div>
    <div class="col-10 px-3">
      <span class="py-1">
        {{data}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultBox',
  props: ['data', 'type'],
};
</script>
